import { apiUrl } from '../config';
import { fetch, handleApiError } from '../utils/http';

export function fetchReportsStart(report) {
    return {
        type : 'REPORTS_FETCH_START',
        report
    }
}

export function fetchReportsSuccess(report, data) {
    return {
        type : 'REPORTS_FETCH_SUCCESS',
        report,
        data
    }
}

export function fetchReportsFailure(report, error) {
    return {
        type : 'REPORTS_FETCH_FAILURE',
        report,
        error
    }
}

export function fetchReports(report, page, filters) {
    return function(dispatch) {
        dispatch(fetchReportsStart(report));
        const url = `${apiUrl()}/reports/${report}`;
        const params = Object.assign({}, filters, {page : page || 1});
        fetch(url, {
            queryParams : params
        })
            .then(response => response.json())
            .then(json => dispatch(fetchReportsSuccess(report, json)))
            .catch(error => handleApiError(error, dispatch, (error) => fetchReportsFailure(report, error)))
    }
}

function requestXlsxStart(report) {
    return {
        type : 'REPORT_REQUEST_START'
    }
}

function requestXlsxSuccess(report, data) {
    return {
        type : 'REPORT_REQUEST_SUCCESS',
        report,
        data
    }
}

function requestXlsxFailure(report, error) {
    return {
        type : 'REPORT_REQUEST_FAILURE',
        report,
        error
    }
}

export function requestXlsx(report, filters) {
    return (dispatch) => {
        dispatch(requestXlsxStart(report));
        const url = `${apiUrl()}/reports/${report}`;
        fetch(url, {
            queryParams : {
                ...filters,
                export : 'xlsx'
            }
        })
            .then(response => response.json())
            .then(json => dispatch(requestXlsxSuccess(report, json)))
            .catch(error => dispatch(requestXlsxFailure(report, error)))
    }
}

export function clearXlsxData() {
    return {
        type : 'REPORT_REQUEST_CLEAR'
    }
}


/** WEBPACK FOOTER **
 ** ./src/actions/reports.js
 **/